import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { GoogleMaps } from './app/google-map-util';
import { Preconnect } from './app/preconnect';

if (environment.production) {
    enableProdMode();
}
GoogleMaps.initiazeScript();
Preconnect.setPreconnectLink();

function loadRecaptcha(siteKey: string): void {
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${siteKey}`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
}

loadRecaptcha(environment.recaptchaEnterpriseKey);
platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
